var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tiaojiefuheAll"},[_c('div',{staticClass:"top"},[_c('MyTitle',{attrs:{"title":"调节负荷","type":"1"}})],1),_c('div',{staticClass:"bottom-charts"},[_c('Chart',{attrs:{"cdata":_vm.cdata,"width":'672',"height":'380'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }